<template>
  <layout name="LayoutDefault">
    <div class="About">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row ">
            <div class="col-lg-12 ">
              <div class="col-lg-2 ml-auto p-0">
                <select class="form-control category-order">
                  <option :value="
                    `${baseUrl}blogs?sort=newest`
                  ">Newest First</option>
                  <option :value="
                    `${baseUrl}blogs?sort=oldest`
                  ">Oldest First</option>
                  <option :value="
                    `${baseUrl}blogs?sort=az`
                  ">A-Z</option>
                  <option :value="
                    `${baseUrl}blogs?sort=za`
                  ">Z-A</option>
                </select>
              </div>

              <div class="section-items ">
                <pagination v-bind="pagination">
                  <div slot-scope="{ scope }">
                    <div class="row">
                      <div v-for="(item, k) in scope" :key="k" class="col-lg-2 col-sm-6 col-12 mb-2 section-item books">
                        <a :href="`${baseUrl}blogs/${item.id}`">
                          <ProductImage :image="item.image" />
                          <h4 v-if="item.title.length < 14">
                            {{ item.title }}
                          </h4>
                          <h4 v-if="item.title.length >= 14" :title="`${item.title}`">
                            {{ item.title.substr(0, 14) + "..." }}
                          </h4>
                        </a>
                        <div class="item-price">
                          {{ item.short_description }}
                        </div>
                      </div>
                    </div>
                  </div>
                </pagination>

                <div v-if="pagination.items.length < 1 && !loading">
                  কোন ব্লগ পাওয়া যায়নি।
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";
import VueLoadImage from "vue-load-image";
import Pagination from "vue-and-pagination";
import ProductImage from './common/ProductImage.vue';

export default {
  title:"ব্লগ",
  data() {
    return {
      categoryName: "Loading...",
      loading: true,
      pagination: {
        items: [],
        limit: 12,
        controlsOnTop: false,
        controlsOnBottom: true,
        page: 1,
        sidePagesNumber: 2
      }
    };
  },
  components: {
    Layout,
    ProductImage,
    "vue-load-image": VueLoadImage,
    Pagination
  },
  methods: {
    async getBlogs() {
      const sort = this.$route.query.sort || "newest";
      const response = await this.$http.get(`cms-with-pagination?type=Blog&sort=${sort}`);
      this.pagination.items = response.data.data;
      this.loading = false;
    }
  },
  mounted() {
    this.getBlogs();
  }
};
</script>
